import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3v7z4ym1tg: FaireBrandEntity = {
  token: "b_3v7z4ym1tg",
  type: "brand",
  name: "Dr. Doug's Miracle Balms",
  avatarUrl:
    "https://cdn.faire.com/fastly/faf65698e955a0ad042a5155b5d53e819164c93cedfb39b74aed085dc9153b6a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ea303d1007d79190815fc3625dc3ebf16e2887c9950cdf47a9e5762b7053ce2a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/faf65698e955a0ad042a5155b5d53e819164c93cedfb39b74aed085dc9153b6a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ea303d1007d79190815fc3625dc3ebf16e2887c9950cdf47a9e5762b7053ce2a.png",
  location: "Carmel, IN, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Dr. Doug, a Neurologist and the actual doctor behind Dr. Doug’s Balms—mixed up his first batch of skin care in his kitchen to help ease the bumps and scrapes that came from obstacle course racing. Dr. Doug leaned on his experience in the military as well as his career as a physician to create natural body care that went beyond just skin deep.\n\nSince then Doug has teamed up with co-founder Natalie Gardner to share his all-natural skin soothers with folks. The base of all the balms is organic and deeply moisturizing coconut oil, olive oil and beeswax that is rounded out with essential oils. From there you can opt for added zinc oxide sun protection, natural insect repellent from lemongrass oil, and even ache and pain relief from muscle-soothing magnesium and arnica. It’s all organic and Made in the USA to help treat bodies to what they need to feel good.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:19.097Z",
    importedBy: "entity-db-cli",
  },
};
